import { useEffect, useState } from 'react';

function Countdown() {
  const calculate = () => {
    const d = Math.max(0, new Date('2026-09-12T20:00:00-03:00').getTime() - Date.now());
    return [Math.floor(d/86400000), Math.floor(d/3600000)%24, Math.floor(d/60000)%60, Math.floor(d/1000)%60];
  };
  const [time,setTime] = useState(calculate);
  useEffect(() => { const id=setInterval(()=>setTime(calculate()),1000); return()=>clearInterval(id); },[]);
  return <div className="ys-countdown"><div className="ys-count-title"><i />FALTAM:<i /></div><div className="ys-count-grid">
    {time.map((n,i)=><div key={i}><strong>{String(n).padStart(2,'0')}</strong><span>{['DIAS','HORAS','MINUTOS','SEGUNDOS'][i]}</span></div>)}
  </div></div>;
}

export default function HeroSection() {
  return <section id="inicio" className="ys-hero">
    <div className="ys-hero-photo" />
    <div className="ys-vignette" />
    <img className="ys-left-official" src="/assets/rosas-esquerda-v2.png" alt="" />
    <div className="ys-hero-copy"><p>MEUS 15 ANOS</p><img className="ys-official-signature" src="/assets/assinatura-yasmin-vertical.png" alt="Yasmin Siqueira XV"/><blockquote>Um sonho que se<br/>torna realidade!</blockquote></div>
    <Countdown />
  </section>;
}
